import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { StoreAddService } from '../store-add.service';
import { StoreDetailService } from 'src/app/core/store/store-detail.service';
import { IsochroneService } from 'src/app/core/depot/isochrone.service';
import { ReportService } from 'src/app/core/service/report.service';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { ComparisonType } from 'src/app/core/store/ranking/comparison-type.enum';
import { RegionType } from 'src/app/core/location/region-type.enum';
import { KeyIndicatorType } from 'src/app/core/user-preferences/key-indicator-type.enum';
import { FeatureCollection } from 'src/app/core/models';
import { CircleRequest } from 'src/app/core/shared/shape/circle-request';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { debounceTime } from 'rxjs/operators';
import { SpinnerSize } from 'src/app/core/util/spinner/spinner-size.enum';
import { roundToThousand } from 'src/app/core/util/math-utils';
import { HitTrackingService } from 'src/app/core/hit-tracking/hit-tracking.service';
import { USER_TRACKING_ACTION_DESCRIPTIONS, USER_TRACKING_ACTIONS, USER_TRACKING_SOURCES } from 'src/app/core/constants/user-tracking.constants';

@Component({
  standalone: false,
  selector: 'mtn-competitive-analysys',
  templateUrl: './competitive-analysys.component.html',
  styleUrl: './competitive-analysys.component.scss'
})
export class CompetitiveAnalysysComponent implements OnInit, AfterViewInit {
  @Input() trackingContext: { grocer: string; location: string; sqft: string; cbsaName: string };
  @Input()
  location: any;
  @Input()
  grocer: any;
  @Input()
  sqft: any;
  @Input()
  cbsaName: any;
  @Input()
  coardinates: any = '';
  private readonly VALIDATORS_DRIVE_TIME = [
    Validators.min(1),
    Validators.max(20),
  ];
  private readonly VALIDATORS_RING = [Validators.min(1), Validators.max(10)];
  private readonly DEFAULT_COLUMNS: string[] = ['name', 'value', 'totalCount'];
  displayedColumns: string[] = this.DEFAULT_COLUMNS;
  isLoading = false;
  dataSource = new MatTableDataSource<any>([]);
  keyIndicatorForm: FormGroup;
  form: FormGroup;
  totalLength = 0;
  roundToThousand = roundToThousand;
  @Output() dataEmitter: any = new EventEmitter();
  @Output() regionAndComparType: any = new EventEmitter();
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('paginator') paginator: MatPaginator;
  @ViewChild('table') table: MatTable<any>;
  bannerCoardinates: any;
  SpinnerSize = SpinnerSize;
  constructor(private fb: FormBuilder,
    public storeAddService: StoreAddService,
    public storeDetailService: StoreDetailService,
    private isochrone: IsochroneService,
    private hitTracking: HitTrackingService,
    private reportService: ReportService) {
  }

  ngOnInit(): void {
    this.initializeForms();
    this.loadMinutes(7);
    this.bannerFormChnagesSubscription();
    this.initRegion();
    let regionValue;

    if (this.form?.value.region === 'DRIVE_TIME') {
      regionValue = `${this.form?.value.driveTimeMinutes} minutes`;
    } else if (this.form?.value.region === 'RING') {
      regionValue = `${this.form?.value.ringMiles} miles`;
    }

    this.regionAndComparType.emit({ keyIndicator: this.keyIndicatorForm.value.keyIndicator, regionType: this.form?.value?.region, regionValue: regionValue })

  }



  bannerFormChnagesSubscription() {
    this.form.valueChanges
      .pipe(debounceTime(300))
      .subscribe((formValue: any) => {
        if (formValue.region == 'MARKET_AREA') {
          this.loadMarketArea();
        } else if (formValue.region == 'DRIVE_TIME') {
          this.loadMinutes(formValue.driveTimeMinutes);
        } else if (formValue.region == 'RING') {
          this.loadRingMiles(formValue.ringMiles);
        }
      })
    this.keyIndicatorForm.valueChanges.pipe(debounceTime(300)).subscribe(() => {
      this.callBannerData('keyIndicatorForm changed');
    });
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.sort.active = 'value'; // Default sorted column
    this.sort.direction = 'desc';
    this.sort.sortChange.emit(); // Apply default sorting
  }
  initializeForms() {
    this.form = new UntypedFormGroup({
      comparisonType: new UntypedFormControl(ComparisonType.ALL, [
        Validators.required,
      ]),
      driveTimeMinutes: new UntypedFormControl(7, this.VALIDATORS_DRIVE_TIME),
      region: new UntypedFormControl(RegionType.MARKET_AREA, [
        Validators.required,
      ]),
      ringMiles: new UntypedFormControl(3, this.VALIDATORS_RING),
    });
    this.keyIndicatorForm = this.fb.group({
      keyIndicator: new UntypedFormControl(KeyIndicatorType.SALES_SQFT, [
        Validators.required,
      ]),
    });
  }

  loadMarketArea() {
    this.isLoading = true;
    this.storeAddService.loadMarketArea(this.coardinates).subscribe({
      next: (result: any) => {
        this.isLoading = false;
        if (result.features[0]?.properties) {
          result.features[0]['properties'] = {};
        }
        this.bannerCoardinates = result;
        this.callBannerData('loadMarketArea');
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }
  loadMinutes(minutes: number) {
    this.isLoading = true;
    const request: any = {
      point: {
        lat: this.coardinates.lat,
        lng: this.coardinates.lng,
      },
      travelTimeMinutes: minutes,
    };

    this.isochrone.findOneIsochrone(request).subscribe({
      next: (result: FeatureCollection) => {
        this.isLoading = false;
        this.bannerCoardinates = result;
        this.callBannerData('loadMinutes');
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }
  loadRingMiles(miles: number) {
    this.isLoading = true;
    const circleRequest: CircleRequest = new CircleRequest();
    circleRequest.point = {
      type: 'Point',
      coordinates: [this.coardinates.lat, this.coardinates.lng],
    };
    circleRequest.distanceMiles = miles;
    return this.reportService.createOne(circleRequest).subscribe({
      next: (result: FeatureCollection) => {
        this.isLoading = false;
        this.bannerCoardinates = this.convertToGeoJSON(result);
        this.callBannerData('loadRingMiles');
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  callBannerData(from: string) {
    console.log(from)
    this.loadData(this.bannerCoardinates).subscribe({
      next: (result: any) => {
        this.isLoading = false;

        if (result.length > 0) {
          const { average, totalStores } = this.calculateWeightedAverage(result);
          const regionType = this.form?.value.region;
          const keyIndicator = this.keyIndicatorForm?.value.keyIndicator;

          let regionValue;
          if (regionType === 'DRIVE_TIME') {
            regionValue = `${this.form?.value.driveTimeMinutes} minutes`;
          } else if (regionType === 'RING') {
            regionValue = `${this.form?.value.ringMiles} miles`;
          } else {
            regionValue = 'Market Area';
          }
          const baseDescription = USER_TRACKING_ACTION_DESCRIPTIONS[USER_TRACKING_ACTIONS.COMPETITIVE_SUMMARY_CHANGED];
          this.hitTracking.hitTheUserTracking(
            USER_TRACKING_SOURCES.COMPETITIVE_ANALYSIS_COMPONENT,
            { region: regionValue, keyIndicator: keyIndicator, location: this.location, grocer: this.trackingContext.grocer, cbsa: this.trackingContext.cbsaName, sqft: this.trackingContext.sqft },
            USER_TRACKING_ACTIONS.COMPETITIVE_SUMMARY_CHANGED,
            baseDescription
          ).subscribe(() => {});

          this.totalLength = result.length + 1;
          this.dataSource.data = [
            {
              uuid: 1,
              name: 'All Grocery',
              value: keyIndicator === 'SALES_VOLUME' ? this.roundToThousand(average) : average.toFixed(2),
              totalCount: totalStores,
            },
            ...result,
          ];

          setTimeout(() => {
            this.dataEmitter.emit(this.dataSource.data);
            this.regionAndComparType.emit({
              keyIndicator,
              regionType,
              regionValue
            });

            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            this.table.renderRows();
          });

        } else {
          this.totalLength = 0;
          this.dataSource.data = [];
        }

        this.isLoading = false;
      },
      error: (err: any) => {
        this.totalLength = 0;
        this.dataSource.data = [];
        setTimeout(() => {
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        });
        this.isLoading = false;
        console.error('Error fetching banner data:', err);
      }
    });
  }




  private initRegion(): void {
    const defaultRegion: RegionType = RegionType.DRIVE_TIME;

    this.form.get('region')?.setValue(defaultRegion, { emitEvent: false });
  }

  loadData(marketAreaCoardinate: any) {
    const request: any = {
      geoJson: marketAreaCoardinate,
      comparisonType: 'ALL',
      keyIndicator: this.keyIndicatorForm.value.keyIndicator,
      salesSqftDisplayType: 'SALES_AREA',
      salesVolumeDisplayType: 'WEEKLY',
    };

    return this.storeAddService.getBannerData(request);
  }

  convertToGeoJSON(data: any): any {
    const updatedData = JSON.parse(JSON.stringify(data));
    updatedData.features.forEach((feature: any) => {
      if (feature.geometry && feature.geometry.coordinates) {
        feature.geometry.coordinates = feature.geometry.coordinates.map(
          (polygon: any) =>
            polygon.map((coordinate: any) => [coordinate[1], coordinate[0]]) // Switch [lat, lon] to [lon, lat]
        );
      }
    });

    return updatedData;
  }

  calculateWeightedAverage(data: any) {
    let totalSales = 0;
    let totalStores = 0;

    data.forEach((item: any) => {
      totalSales += item.value * item.totalCount; // Sum of (Value × TotalCount)
      totalStores += item.totalCount; // Sum of TotalCount
      item.value = this.keyIndicatorForm.value.keyIndicator == 'SALES_VOLUME' ? this.roundToThousand(item.value) : item.value;
    });

    return { average: totalSales / totalStores, totalStores }; // Weighted Average
  }

}
